export default __webpack_public_path__ + "static/title-9f8802467ee9049e4f783e649c983d76.png";